/**
 * Reads a nested property using dot-separated keys.
 */
export function getByPath(obj: unknown, path: string): unknown {
  if (path === '') {
    return obj;
  }
  if (obj == null) {
    return undefined;
  }

  const keys = path.split('.');
  return keys.reduce<unknown>((cur, key) => {
    if (cur == null || typeof cur !== 'object') {
      return undefined;
    }
    return (cur as Record<string, unknown>)[key];
  }, obj);
}
